import React, { useState } from "react";
import { Send, Sparkles, RotateCcw } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useChatSession } from "../hooks/useChatSession";
import { ChatMessages, ChatInput } from "./chat/ChatParts";

export const AdminAssistant = () => {
  const { t, lang } = useLang();
  const [input, setInput] = useState("");
  const { messages, sending, send, reset } = useChatSession({
    prefix: "admin", endpoint: "/admin/assistant", latestEndpoint: "/admin/assistant/latest", errorText: t("assistant_error"),
  });
  const dir = lang === "ar" ? "rtl" : "ltr";
  const submit = () => { const text = input.trim(); if (!text) return; setInput(""); send(text); };

  return (
    <div data-testid="admin-assistant">
      <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
        <div>
          <h1 className="serif text-3xl flex items-center gap-3"><Sparkles size={22} className="text-[#C49A6C]" /> {t("assistant_title")}</h1>
          <p className="text-sm text-[#8A857D] mt-2 max-w-xl leading-relaxed">{t("assistant_sub")}</p>
        </div>
        <button onClick={reset} data-testid="assistant-new-chat" className="flex items-center gap-2 border border-[#262421] px-4 py-2 text-xs uppercase tracking-widest text-[#8A857D] hover:text-[#F2EBE1] hover:border-[#C49A6C] transition-colors">
          <RotateCcw size={14} /> {t("assistant_new")}
        </button>
      </div>
      <div className="border border-[#262421] bg-[#0F0F0F] flex flex-col h-[62vh]">
        <ChatMessages messages={messages} sending={sending} intro={t("assistant_intro")} thinking={t("assistant_thinking")}
          testPrefix="assistant" dir={dir} size="px-4 py-3 text-[15px]" className="flex-1 overflow-y-auto p-5 md:p-6 space-y-4" />
        <ChatInput value={input} onChange={setInput} onSend={submit} disabled={sending || !input.trim()} placeholder={t("assistant_placeholder")}
          dir={dir} testPrefix="assistant" inputClass="px-4 py-3 max-h-40">
          <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] px-5 py-3.5"><Send size={15} /> {t("assistant_send")}</span>
        </ChatInput>
      </div>
    </div>
  );
};
